import { Holder } from '@maverick/ui';
import { FC } from 'react';

import * as Styled from './Aarp.styled';

export const Aarp: FC = () => {
	return (
		<Styled.Container>
			<Holder>
				<Styled.Title>SPECIAL OFFER FOR AARP MEMBERS SAVE⁠ 1​0﻿⁠⁠%</Styled.Title>

				<Styled.Main>
					Show your valid AARP membership card and receive 10% off your entire check.* To receive the discount
					on online orders, select ‘Pay at Restaurant’ and then show your AARP membership card when picking up
					your order. Discount will be added during pickup at the restaurant.
				</Styled.Main>

				<Styled.Image></Styled.Image>
				<Styled.Description>
					This offer is only valid for AARP members.
					<br />
					<br />
					*VALID FOR LUNCH OR DINNER at participating Outback Steakhouse® locations in the US. Not valid for
					online orders. No coupon required. 10% off AARP member’s entire guest check (excluding alcohol, gift
					cards, applicable taxes and gratuity) with show of valid AARP membership card. One offer, per check,
					per table. Offer has no cash value. Prices and product participation may vary by location. Not valid
					in conjunction with any other offer or discount. Not valid before or after valid dates.
					<br />
					<br />
					AARP member benefits are provided by third parties, not by AARP or its affiliates. Providers pay a
					royalty fee to AARP for the use of its intellectual property. These fees are used for the general
					purposes of AARP. Some provider offers are subject to change and may have restrictions. Please
					contact the provider directly for details.
				</Styled.Description>
			</Holder>
		</Styled.Container>
	);
};
